<template>
    <div>
        <v-row class="no-frame mt-0 mb-3 ro-background pb-1">
            <v-col class="no-frame pr-2 pl-2 v-flex col-9">
                <v-switch
                    v-model   = "contract.active"
                    label     = "Vertrag aktiv"
                    :readonly = "true"
                    :ripple   = "false"
                    class     = "ma-0"
                    hide-details
                />
                <div v-if="contract.unit && contract.unit.terminate" style="font-size: 14px; padding-top: 6px; padding-left: 4px" class="error--text">
                    Vertrags wird beendet
                </div>
            </v-col>
            <v-col class="no-frame pb-0 mb-0">
                <div style="padding-top: 5px; text-align: right; font-size: 15px;" class="w-100 pr-2">
                    <span class="primary--text">{{ $t('contract.hcid') }}</span>
                    <span class="pl-2">{{ contract.id === 0 ? '---' : contract.id }}</span>
                </div>
            </v-col>
        </v-row>

        <v-row class="no-frame mt-0 mb-0">
            <f-read-only-field
                class="w-100"
                :label = "$t('contract.company')"
                :value = "contract.company.name"
                color="pt-0-5 pl-1 ro-background"
            />
        </v-row>

        <v-row class="no-frame mt-0 mb-0" v-if="showTier">
            <f-read-only-field
                class="w-100"
                :label = "$t('contract.lim.tier')"
                :value = "contract.tier.name"
                color="pt-0-5 pl-1 ro-background"
            />
        </v-row>

        <v-row class="no-frame">
            <v-col class="no-frame pr-2">
                <f-read-only-field
                    v-if   = "readonly"
                    class  = "w-100"
                    style="margin-top: 5px"
                    :label = "$t('contract.start')"
                    :value = "dateAsString(contract.unit.start)"
                    color  = "pt-0-5 pl-1 ro-background"
                />
                <f-date-picker
                    v-if      = "!readonly"
                    v-model   = "contract.unit.start"
                    label     = "contract.start"
                    :rules    = "[ requiredRule]"
                />
            </v-col>
            <v-col class="no-frame p-2">
                <f-read-only-field
                    v-if   = "readonly"
                    class  = "w-100"
                    style="margin-top: 5px"
                    :label = "$t('contract.expiration')"
                    :value = "dateAsString(contract.unit.end)"
                    :color = "'pt-0-5 pl-1 ro-background ' + (contract.unit.terminate ? 'error--text' : '')"
                />
                <f-date-picker
                    v-if      = "!readonly"
                    v-model   = "contract.unit.end"
                    label     = "contract.expiration"
                    :rules    = "[ requiredRule]"
                />
            </v-col>
        </v-row>

<!--
        <v-row class="no-frame">
            <v-col class="no-frame pr-2">
                <f-read-only-field
                    v-if   = "readonly"
                    class  = "w-100"
                    style="margin-top: 5px"
                    label = "Kündigungsdatum"
                    value = ""
                    color  = "pt-0-5 pl-1 ro-background"
                />
            </v-col>
            <v-col class="no-frame p-2">
                <f-read-only-field
                    v-if   = "readonly"
                    class  = "w-100"
                    style="margin-top: 5px"
                    label = "Gekündigt zum"
                    value = ""
                    :color = "'pt-0-5 pl-1 ro-background ' + (contract.unit.terminate ? 'error--text' : '')"
                />
            </v-col>
        </v-row>
        -->
    </div>
</template>

<script>

import Core            from "@/modules/core/service/Core";
import FReadOnlyField  from "@/modules/core/components/utils/FReadOnlyField.vue";
import FDatePicker     from "@/modules/core/components/utils/FDatePicker.vue";
import { shouldDisplayTierChip } from "@/modules/msd/company/contract/service/ContractTier";

export default {
    name: "PSiteContractHeader",
    components: {
        FReadOnlyField,
        FDatePicker
    },

    props: {
        contract: {
            required: true,
            type    : Object,
        },

        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },
    },

    computed: {
        requiredRule() {
            return Core.rule.required;
        },

        showTier () {
            return shouldDisplayTierChip(this.contract);
        },
    },

    methods: {
        dateAsString (value) {
            return Core.format.date.display(value);
        }
    }
}
</script>

<style scoped>

</style>